<template lang="html">
  <div class="photos">
    <div class="container">

      <div class="row">
        <h2 class="title">{{ $t('telas.fotos.titulo') }}</h2>
      </div>

      <div class="popup-gallery">

        <div class="opcoes">
          <p class="font-center">
            <button type="button" class="btn btn-muda-foto" v-bind:class="{ 'btn-dark': jardim[0], 'btn-info': jardim[1]}" @click="changePhoto('jardim')">{{ $t('telas.fotos.botao.a_pousada') }}</button>
            <button type="button" class="btn btn-muda-foto" v-bind:class="{ 'btn-dark': restaurante[0], 'btn-info': restaurante[1]}" @click="changePhoto('restaurante')">{{ $t('telas.fotos.botao.restaurante') }}</button>
          </p>
        </div>

        <p id="info">
          <span class="red">*</span> {{ $t('telas.fotos.descricao.ampliar_imagem') }}
        </p>

        <span v-for="(photo, id) in photos">
          <div
            v-if="opcao == 'all' || (opcao != 'all' && photo.categoria == opcao)"
            class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 mini-image-div">
            <a :href="photo.url" :title="photo.title">
              <img :src="photo.url" alt="" class="mini-image">
            </a>
          </div>
        </span>
      </div>

      <!-- reserva -->
      <reserva :header="true"></reserva>

    </div> <!-- container -->

  </div>
</template>

<script>
import reserva from '../../components/reservation-component/ReservationComponent'
import { urlBase } from '../../../config/url'

export default {
  name: 'Photo',

  components: {
    reserva
  },

  data(){
    return {
      opcao: 'all',
      jardim: [true, false],
      restaurante: [true, false],
      photos: []
    };
  },

  created(){
    try {
      for(let i = 28; i <= 47; i++){
        this.photos.push({
          url: require(`@/assets/img/pousada/${i}.jpg`),
          categoria: 'jardim', title: 'Área de lazer'
        })
      }
    } catch(e) {
      console.error("Houve um erro ao carregar as fotos da pousada. ", e)
    }

    try {
      for(let i = 1; i <= 16; i++){
        this.photos.push({
          url: require(`@/assets/img/restaurante/${i}.jpg`),
          categoria: 'restaurante', title: 'Restaurante'
        })
      }
    } catch(e) {
      console.error("Houve um erro ao carregar as fotos do restaurante. ", e)
    }
  },

  mounted() {
    $(document).ready(function() {
    	$('.popup-gallery').magnificPopup({
    		delegate: 'a',
    		type: 'image',
    		tLoading: 'Carregando imagem #%curr%...',
    		mainClass: 'mfp-img-mobile',
    		gallery: {
    			enabled: true,
    			navigateByImgClick: true,
    			preload: [0,1]
    		},
    		image: {
    			tError: '<a href="%url%">A imagem #%curr%</a> não carregou.',
    			titleSrc: function(item) {
    				return item.el.attr('title') + '<small>Pousada Tranquilândia Village</small>';
    			}
    		}
    	});
    });
  },

  methods: {
    changePhoto(valor){
      this.opcao = valor
      this.jardim[0] = this.jardim[1] = false
      this.restaurante[0] = this.restaurante[1] = false

      if(valor == 'restaurante') {
        this.restaurante[1] = true
        this.jardim[0] = true
      } else if(valor == 'jardim') {
        this.jardim[1] = true
        this.restaurante[0] = true
      }
    }
  }
}
</script>

<style lang="css">
.photos {
  background-color: white;
  font-family: 'Quicksand', sans-serif;
  padding-bottom: 80px;
  padding-top: 100px;
}
.photos .container .row h2.title {
  width: 100%;
  text-align: center;
  color: rgb(118, 106, 49);
}
.opcoes {
  width: 100%;
  margin-top: 40px;
  margin-bottom: 30px;
}
.opcoes .btn-muda-foto {
  margin-bottom: 5px;
}
p#info {
  color: black;
  font-size: 17px;
  margin-left: 15px;
}
.photos .container .popup-gallery .mini-image-div {
  display: inline-block;
  margin-bottom: 10px;
}
.photos .container .popup-gallery .mini-image-div .mini-image {
  width: 100%;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/photo/Photo.vue